"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment } from "react";
import Image from "@/components/common/image/image";
import Link, { LinkType } from "../../../link/link";
import css from "../header-menu.module.scss";
import { NavItemWithKey } from "../header-menu";
interface ISubMenuCardProps {
  data: NavItemWithKey;
}
const SubMenuCard = props => {
  const $ = _c(18);
  const {
    data
  } = props;
  const {
    submenuTitle,
    submenuDescription,
    link,
    submenuCtaLabel,
    benefits
  } = data;
  let t0;
  if ($[0] !== submenuTitle) {
    t0 = <span className={css.subMenuCardTitle}>{submenuTitle}</span>;
    $[0] = submenuTitle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== submenuDescription) {
    t1 = <p className={css.subMenuCardDescription}>{submenuDescription}</p>;
    $[2] = submenuDescription;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = link?.href ?? "";
  const t3 = link?.nofollow;
  let t4;
  if ($[4] !== submenuCtaLabel) {
    t4 = <span className="whitespace-nowrap">{submenuCtaLabel}</span>;
    $[4] = submenuCtaLabel;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src="/back-arrow.svg" alt="" width={24} height={24} className={css.subMenuCardCtaIcon} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t6 = <Link href={t2} className="mb-6 h-[56px] !w-full gap-3 !bg-[#373B37] hover:!bg-[#00698f]" rel={t3} linkType={LinkType.BUTTON}>{t4}{t5}</Link>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== benefits) {
    t7 = !!benefits?.length && <div className="flex items-center gap-2"><Image src="/ssn.svg" alt="" width={18} height={18} className={css.menuIcon} />{benefits.map((benefit, index) => <Fragment key={index}><span className="text-xs font-normal">{benefit}</span>{index < benefits.length - 1 && <div className="h-[12px] w-[1px] bg-[#4A4A4A]" />}</Fragment>)}</div>;
    $[11] = benefits;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t0 || $[14] !== t1 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className={css.subMenuCard}>{t0}{t1}{t6}{t7}</div>;
    $[13] = t0;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default SubMenuCard;